
import { Component, OnInit, Renderer2, ElementRef, PLATFORM_ID, Inject, HostListener, ViewChild, OnDestroy, AfterViewInit, TransferState, makeStateKey } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MktSiteCatalystService } from '../../core/services/mkt-site-catalyst.service';
import { isPlatformBrowser } from '@angular/common';
import { MktDynamicOfferService } from '../../core/services/mkt-dynamic-offer.service';
import { MktSEOService } from '../../core/services/mkt-seo.service';
import { Title } from '@angular/platform-browser';
import { MktContentService } from '../../core/services/mkt-content.service';
import { MktModalService } from '../../core/services/mkt-modal.service';
import { combineLatest, Subscription, takeWhile, tap } from 'rxjs';
import { MktTaggingTransformationService } from '../../core/services/mkt-tagging-transformation.service';
import { MktBrandingService } from 'src/app/common/services/mkt-branding.service';
import { OfferUtilService } from 'src/app/common/services/offer-util.service';
import { MktEventListnerService } from 'src/app/common/services/mkt-event-listner.service';
import { costcoRewardsSectionJoinLink, costcoBusinessRewardsSectionJoinLink, costcoJoinLink, costcoBusinessJoinLink, exitLink, wayfairAccountexitLinkSection1, wayfairAccountexitLinkSection2, benefitSectionNewTabLink0, benefitSectionNewTabLink1, benefitSectionNewTabLink2 } from './constants/pdp-anchor-tagging';
import { PDPAPPLYNOWTAGGING } from './constants/pdp-applynow-tagging';
import { RouteValidatorService } from 'src/app/core/services/route-validator.service';
import { CdsSliderModule, Accordion2, CdsIconModule } from '@citi-gcg-173875/citi-common-ui-cds';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { BenefitSectionComponent } from './benefit-section/benefit-section.component';
import { EarningsCalculatorSectionComponent } from './earnings-calculator-section/earnings-calculator-section.component';
import { FeatureSectionComponent } from './feature-section/feature-section.component';
import { HeaderSectionComponent } from './header-section/header-section.component';
import { PdpCompareCardsComponent } from './pdp-compare-cards/pdp-compare-cards.component';
import { PriceDetailSectionComponent } from './price-detail-section/price-detail-section.component';
import { ProgramDetailSectionComponent } from './program-detail-section/program-detail-section.component';
import { ReviewSectionComponent } from './review-section/review-section.component';
import { RewardsSectionComponent } from './rewards-section/rewards-section.component';
import { FaqSectionComponent } from './faq-section/faq-section.component';
import { QPStoreService } from 'src/app/common/services/qp-store.service';

const IS_PAGE_NOT_FOUND_KEY = makeStateKey<boolean>('isPDPPageNotFound');
const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>("isBundleLoaded");
const CARDS_WITH_RATINGS_KEY = makeStateKey("cardsWithRatings");
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const MBOL_PRE_LOGIN = 'mbol_cards_prelogin_acq';
const MBOL_POST_LOGIN = 'mbol_cards_cs_acq';
const PDP_CALL_TO_APPY_PID_LIST = ['051', '056', '089', '093', '142', '202', '257', '408', '410', '416', '520', '522'];

@Component({
  selector: 'app-pdp',
  templateUrl: './pdp.component.html',
  styleUrls: ['./pdp.component.scss'],
  standalone: true,
  imports: [
    MktCommonModule,
    SlickCarouselModule,
    CdsSliderModule,
    Accordion2,
    CdsIconModule,
    HeaderSectionComponent,
    RewardsSectionComponent,
    ProgramDetailSectionComponent,
    BenefitSectionComponent,
    FaqSectionComponent,
    ReviewSectionComponent,
    FeatureSectionComponent,
    PriceDetailSectionComponent,
    PdpCompareCardsComponent,
    EarningsCalculatorSectionComponent,
  ],

})
export class PdpComponent implements OnInit, AfterViewInit, OnDestroy {
  cardName: string;
  afcCode: string;
  intcCode: string;
  category: string;
  flowId: string;
  mainPdpContentObject: any;
  cardDetails: any = null;
  seoTags: any = {};
  siteCatalyst: any = {};
  pid: string;
  screenId: string;
  prodName: string;
  screenWidth: number;
  isModalOpen: boolean;
  modalUrl: string;
  pageNotFound = false;
  routeSub: Subscription = new Subscription();
  private sub: Subscription = new Subscription();
  mbolFlagPreLogin: string;
  mbolFlagPostLogin: string;
  soc: string;
  rafid: string;
  pageId: string;
  displayFeatureSection: boolean;
  isExpired: boolean;
  isComponentActive = true
  productType: string;
  pidPT: string;

  // isAddlInfoOverlayOpen: boolean = false;
  externalUrlClicked: any;
  @ViewChild('faqAccordion') faqAccordion;
  isRafLinkExpired: boolean;
  isBundleLoaded: boolean;
  isAdditionalBundleLoaded: boolean;
  isBrowser: boolean;
  productName: string;
  hashCode: string;
  taggingObj;
  pdpDisplayOrder;
  pdpDisplayOrderName = PdpDisplayOrderName;
  applyNowUrl;
  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private _mktContentService: MktContentService,
    private mktDynamicOfferService: MktDynamicOfferService,
    private mktSEOService: MktSEOService,
    private mktSiteCatalystService: MktSiteCatalystService,
    private _offerUtilService: OfferUtilService,
    private modalService: MktModalService,
    private route: ActivatedRoute,
    private renderer2: Renderer2,
    public state: TransferState,
    private titleService: Title,
    private _mktTagging: MktTaggingTransformationService,
    private _mktEventListnerService: MktEventListnerService,
    private mktBrandingService: MktBrandingService,
    private qpstoreService: QPStoreService,
    @Inject(PLATFORM_ID) private _platformId: string,
    private routerValidator: RouteValidatorService
  ) {
    this.isBrowser = isPlatformBrowser(this._platformId);
  }

  ngOnInit() {
    this.routeSub.add(combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe({
      next:
        (params) => {
          this.qpstoreService.setEAPPageQueryParams(params[1] || {});
          this.cardName = params[0]['cardName'].replace(/\./g, '');
          this.flowId = params[1]['flowId'] || "";
          this.afcCode = params[1]['afc'] || "";
          this.soc = params[1]['soc'] || "";
          this.rafid = params[1]['rafid'] || "";
          this.intcCode = params[1]['intc'] || "";
          this.hashCode = params[1]['HKOP'] || "";
          this.category = params[1]['category'] || "view-all-credit-cards";
          this.pageId = (!!this.category && this.category === "raf-aadvantage-credit-card-page") ? "CitiRAFNGA" : 'CitiPDPNGA';
          if (this.category === 'raf-aadvantage-credit-card-page') {
            this.displayFeatureSection = false;
          } else {
            this.displayFeatureSection = true;
          }
          this.loadContent();
        },
      error: (error) => {
        console.error('Unable to complete PDP OnInit: ', error);
        this.router.navigateByUrl('page-not-found');
        this.state.set(IS_PAGE_NOT_FOUND_KEY, true);
      }
    }));
  }
  ngAfterViewInit() {
    this.isBundleLoaded = this.state.get(IS_BUNDLE_LOADED_KEY, false);
    this._joinCostcoOnClick()
    this._exitLinkClicked();
    this.newTabLinkClick();
  }
  ngOnDestroy() {
    this.isComponentActive = false;
    this.sub.unsubscribe();
    this.routeSub.unsubscribe();
    this.modalService.modalArray.forEach(inst => this.modalService.destroyModal(inst));
    if (this.cardDetails?.isCRSPage) this.state.set(PRICE_DETAILS_KEY, []);
  }
  // Trigger Price Data Request
  private getCRSDynamicPricing() {
    this._offerUtilService.getAllDynamicOffer({ pageId: 'CITICRSNGA', affinityId: this.afcCode, category: this.category, screenId: '', intc: this.intcCode, rewardProgramType: 'CRS' }, (message) => {
      console.log(`>>> PDP : CRS Price Load ${message}`);
      this.loadCRSPriceInformation(this.cardDetails?.cardsList || [this.pid]);
    });
    this.taggingDataObj(undefined);
    this.initTaggingTransformationCc(undefined);
    const dynamicUrls = {
      'applyNowUrl': this.cardDetails?.crsApplyNowURL || this.applyNowUrl || '',
      'termsUrl': this.cardDetails?.crsPricingLink || '',
    };
    this.mktDynamicOfferService.setApplyNowContent(dynamicUrls);
    const instance = setTimeout(() => {
      this._offerUtilService.injectDynamicUrls(this.elementRef, this.renderer2, dynamicUrls, this.pid);
      this._mktEventListnerService.upsertElementEvent(exitLink);
      this._mktEventListnerService.upsertElementEvent(benefitSectionNewTabLink0);
      this._mktEventListnerService.upsertElementEvent(benefitSectionNewTabLink1);
      this._mktEventListnerService.upsertElementEvent(benefitSectionNewTabLink2);
      this._mktEventListnerService.upsertElementEvent(wayfairAccountexitLinkSection1);
      this._mktEventListnerService.upsertElementEvent(wayfairAccountexitLinkSection2);
      clearTimeout(instance);
    }, 10);
  };

  private loadCRSPriceInformation(cardsList) {
    cardsList.map((pid) => {
      this._offerUtilService.populateDynamicValues(pid, this.elementRef, this.renderer2);
    });
  }

  private commonOnInit() {
    // this.getCardsWithRatings();
    const bannerConfigContent = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
    this.mktDynamicOfferService.productType = JSON.parse(bannerConfigContent.productType || '{}');
    this.mktDynamicOfferService.pidptArray = JSON.parse(bannerConfigContent.pidptArray || '{}');
    // Try to get card details
    this.mainPdpContentObject = this._mktContentService.get('Product_Detail_Pages', 'copy', this.cardName, undefined);
    this.cardDetails = JSON.parse(this.mainPdpContentObject?.['TEXT'] || '{}');
    this.pid = this.cardDetails['pid'];
    this.productType = this.cardDetails['productType'];
    const pidPT = this.pid + (this.productType ? '_' + this.productType : '');
    // set EAP params in cookie
    const hkopFromCookie = this.qpstoreService.setPDPQPCookie(pidPT);
    this.hashCode = hkopFromCookie ? hkopFromCookie : this.hashCode;
    // Read afc from EAP cookie
    this.afcCode = this.qpstoreService.getAfcCodeFromEAPCookie(this.qpstoreService.PAGE_TYPE_PDP, pidPT) || this.afcCode;
    // Check if cards Detail missing or product is not active or product is disabled/ indark then show 404 page
    if (!this.mainPdpContentObject || (Object(this.cardDetails).hasOwnProperty('productActive') && this.cardDetails?.productActive === false) || (!this.routerValidator.isPublishedProducts([pidPT?.toString()]))) {
      this.router.navigateByUrl('page-not-found');
      this.state.set(IS_PAGE_NOT_FOUND_KEY, this.pageNotFound);
      return;
    }

    this.pdpDisplayOrder = this._getPdpDisplayOrder(this.cardDetails.pdpDisplayOrder)
    this.screenId = this.cardDetails['screenId'];
    if (!this.intcCode) this.intcCode = this.cardDetails['intc'];
    if (!this.afcCode) this.afcCode = this.cardDetails.afc;
    this.titleService.setTitle(this.cardDetails.pageTitle);
    this.seoTags = JSON.parse(this.mainPdpContentObject['seoTags'] || '{}');
    this.siteCatalyst = JSON.parse(this.mainPdpContentObject['siteCatalyst'] || '{}');
    this.prodName = this.siteCatalyst['pageLoadTag']['prodName'];
    this.mbolFlagPreLogin = this.mainPdpContentObject['isPreLoginMBOLFlow'];
    this.mbolFlagPostLogin = this.mainPdpContentObject['isPostLoginMBOLFlow'];
    this.mktSEOService.setContentfulSeoTags(this.seoTags);
    if (this.isBrowser) {
      this.cardDetails?.isCRSPage ? this.getCRSDynamicPricing() : this.getDynamicOffer();
      this.browserOnInit();
    }
  }
  applyCard(pdpMoburl) {
    window.location.href = pdpMoburl;
  }
  private async browserOnInit() {
    if (!isPlatformBrowser(this._platformId)) return;
    // Hide core header for mbol
    if (!!this.flowId && [MBOL_PRE_LOGIN, MBOL_POST_LOGIN].includes(this.flowId)) {
      this.mktBrandingService.hideHeaderFooter();
    }
    // Browser specific code
    this.getScreenWidth();
    // tagging not loaded for PDP page if direct addition information page access
    // if (!this.route.snapshot.data?.isAdditionalInfo) {
    //   this.mktSiteCatalystService.callSC('naAnalyticsPageView', this.siteCatalyst['pageLoadTag']);
    //   this.setTaggingDl();
    // }
    this.attachAnchorSectionScroll();
    this.initializeExternalUrls();
  }
  // private setTaggingDl() {
  //   const taggingIcmsContent = this._mktContentService.get(
  //     'Product_Detail_Pages',
  //     'copy',
  //     'PDP_tagging_content',
  //     undefined
  //   );
  //  // this.mktDynamicOfferService.setTaggingStaticIcms(taggingIcmsContent);
  // }
  private attachAnchorSectionScroll() {
    const anchors = this.elementRef.nativeElement.querySelectorAll('.scroll-to-section');
    [...anchors].forEach(anchor => {
      anchor.addEventListener('click', () => {
        const scrollSection = anchor.getAttribute('data-scroll-target');
        if (scrollSection) {
          const sectionRef = document.querySelector('#' + scrollSection);
          if (!!sectionRef) {
            sectionRef.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
            sectionRef.setAttribute('tabIndex', '0');
            sectionRef.setAttribute('aria-live', 'polite');
            const instance = setTimeout(() => { document.getElementById(`${scrollSection}`).focus(); clearTimeout(instance); }, 500);
          }
        }
      });
    });
  }
  private async loadContent() {
    this.isRafLinkExpired = ((!!this.rafid && !!this.soc) && this._offerUtilService.isRAFJourneyDisable());
    if (this.isRafLinkExpired) return;
    this._offerUtilService.loadBundleContent({ isAddInfo: true });
    this.state.set(IS_BUNDLE_LOADED_KEY, true);
    console.log(`>>> PDP:Bundle Loaded.`);
    // validate Routes Recognized
    this.isBundleLoaded = true;
    // this.loadRatings();
    // PROCESS DATA
    this.commonOnInit();
  }
  // Turn all anchor tags with the class .externalLink into an external link modal
  // This is the best way to scan all innerHtml for external links
  private initializeExternalUrls() {
    setTimeout(() => {
      const externalLinks = this.elementRef.nativeElement.querySelectorAll('.external-link');
      for (let i = 0; i < externalLinks.length; i++) {
        const currentLink = externalLinks[i];
        const hrefValue = currentLink.href;
        this.renderer2.listen(currentLink, 'click', (event) => this.openModal(event, hrefValue));
        this.renderer2.setAttribute(currentLink, 'href', 'javascript:;');
        this.renderer2.setAttribute(currentLink, 'target', '_self');
        this.renderer2.setAttribute(currentLink, 'role', 'link');
        this.renderer2.setAttribute(currentLink, 'tabindex', '0');
      }
    });
  }

  addContent(dynamicVariableSpanElement) {
    this.renderer2.setProperty(dynamicVariableSpanElement, 'innerHTML', dynamicVariableSpanElement.innerHTML);
  }
  removeContent(dynamicVariableSpanElement) {
    this.renderer2.setProperty(dynamicVariableSpanElement, 'innerHTML', '');
  }

  private injectDynamicUrls(urls) {
    for (const key of Object.keys(urls)) {
      const dynamicVariableElementList = this.elementRef.nativeElement.querySelectorAll(`[data-id="${key}"]`);
      const dynamicVariableElementList2 = this.elementRef.nativeElement.querySelectorAll(`[id="${key}"]`);
      const dynamicVariableElementList3 = this.elementRef.nativeElement.querySelectorAll(`[flowId="${key}"]`);
      for (let i = 0; i < dynamicVariableElementList.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList[i];
        this.renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
      for (let i = 0; i < dynamicVariableElementList2.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList2[i];
        this.renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
      for (let i = 0; i < dynamicVariableElementList3.length; i++) {
        const dynamicVariableSpanElement = dynamicVariableElementList3[i];
        this.renderer2.setProperty(dynamicVariableSpanElement, 'href', urls[key]);
      }
    }
  }
  private getDynamicOffer() {
    if (!this.isBrowser) return;
    this.pageId = (!!this.category && this.category === "raf-aadvantage-credit-card-page") ? "CitiRAFNGA" : 'CitiPDPNGA';
    const dynamicOfferServiceReq = this.mktDynamicOfferService.getDynamicOffer(this.pageId, this.pid, this.afcCode, this.hashCode, this.productType);
    this.sub.add(dynamicOfferServiceReq.subscribe({
      next: dynamicOffer => {
        const timeInstance = setTimeout(_ => {
          this._offerUtilService.getPropertyWhenMinMaxSame(dynamicOffer['pricingDetails']);
          const pdpBuildDisplayTermsUrl = this.mktDynamicOfferService.getPricingInfoUrl(this.pid, dynamicOffer['hashCode'], this.cardDetails.app);
          this.hashCode = !!this.hashCode ? this.hashCode : dynamicOffer['hashCode'];
          this.applyNowUrl = this.getApplyNowUrl(this.hashCode, dynamicOffer.offerName, this.cardDetails.app);
          this.taggingDataObj(this.hashCode);
          this.initTaggingTransformationCc(this.hashCode);
          let dynamicUrls = {
            'applyNowUrl': this.applyNowUrl,
            'termsUrl': pdpBuildDisplayTermsUrl,
          };
          this.mktDynamicOfferService.setPriceDetailObj(dynamicOffer['pricingDetails']);
          this.mktDynamicOfferService.setApplyNowContent(dynamicUrls);
          this._offerUtilService.injectDynamicText(this.elementRef, this.renderer2, dynamicOffer['pricingDetails'], this.pid, this.productType);
          this._offerUtilService.injectDynamicUrls(this.elementRef, this.renderer2, dynamicUrls, this.pid);
          this._mktEventListnerService.upsertElementEvent(costcoRewardsSectionJoinLink)
          this._mktEventListnerService.upsertElementEvent(costcoBusinessRewardsSectionJoinLink)
          this._mktEventListnerService.upsertElementEvent(costcoJoinLink)
          this._mktEventListnerService.upsertElementEvent(costcoBusinessJoinLink)
          clearTimeout(timeInstance);
        }, 500);
      },
      error: _ => {
        console.log("PDP price retrive call failed.")
        const pdpApplyNowUrl = this.getApplyNowUrl();
        const pdpBuildDisplayTermsUrl = this.mktDynamicOfferService.getPricingInfoUrl(this.pid, '');
        let dynamicUrl = {
          'applyNowUrl': pdpApplyNowUrl,
          'termsUrl': pdpBuildDisplayTermsUrl
        };
        this.mktDynamicOfferService.setApplyNowContent(dynamicUrl);
        this._offerUtilService.injectDynamicUrls(this.elementRef, this.renderer2, dynamicUrl, this.pid);
      }
    }));
  }
  private getApplyNowUrl(hashCode = '', offerName = null, app = 'UNSOL') {
    let applyNowUrl;
    if ((this.flowId === MBOL_PRE_LOGIN && !!this.mbolFlagPreLogin && this.mbolFlagPreLogin === 'Y') || (this.flowId === MBOL_POST_LOGIN && !!this.mbolFlagPreLogin && this.mbolFlagPostLogin === 'Y')) {
      applyNowUrl = this.mktDynamicOfferService.getMbolApplyNowUrl(this.pid, hashCode, app);
      console.log("Mbol apply now url ", applyNowUrl, " constructed with pre/post mbol flag ", this.mbolFlagPreLogin, this.mbolFlagPostLogin);
    } else {
      applyNowUrl = this.mktDynamicOfferService.getACQApplyNowUrl({
        screenId: this.screenId,
        intc: this.intcCode,
        cardName: this.cardName,
        pid: this.pid,
        hashCode: hashCode,
        isDefaultOffer: this._offerUtilService.isDefaultOffer(offerName),
        afc: this.afcCode,
        soc: this.soc,
        rafid: this.rafid,
        rafcategory: this.category,
        app: app,
      });
      console.log("ACQ apply now url ", applyNowUrl, " constructed with pre/post mbol flag ", this.mbolFlagPreLogin, this.mbolFlagPostLogin);
    }
    return applyNowUrl;
  }
  @HostListener('window:resize', ['$event'])
  private getScreenWidth() {
    this.screenWidth = window.innerWidth;
  }
  private openModal(event, url) {
    this.modalService.openModal(event, {
      url: url,
      isExternalLink: true,
      primaryButtonText: 'Continue',
      target: '_blank'
    });
  }

  private _productDetails() {
    const pids = this.mktDynamicOfferService.pidptArray["pids"];
    for (let str of pids) {
      if (this.pid.toString().includes(str)) {
        let prod_details = this.productName;
        return prod_details;
      }
    }
    return '';
  }

  taggingDataObj(hashCode) {
    const products = [];
    this.productName = this.mktDynamicOfferService.productType[this.pid + (this.productType ? '_' + this.productType : '')];
    const prospect_id = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl)

    products.push({
      category: 'cards:acquisition',
      product_name: 'c:' + ((this.cardDetails?.isCRSPage) ? this.productName : this.pid),
      acquisition_source_code: hashCode,
      product_details: this._productDetails()
    });

    this.taggingObj = {
      pid: ((this.cardDetails?.isCRSPage) ? this.productName : this.pid),
      prospect_id: prospect_id,
      products: products,
      affinity_code: this.afcCode
    }
  }

  private initTaggingTransformationCc(hashCodeAcq) {
    this._mktTagging.tagMktCompareCards("pdpPageView", {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|pdp`
    });
  }

  private _joinCostcoOnClick() {
    this._mktEventListnerService.eventListner$.pipe(
      tap(event => {
        if (event.id === 'costcoJoinLink') {
          const data = this._getCostcoTaggingData({ page_inter: event.domElement.textContent })
          this._mktTagging.tagMktCompareCards('citi-costco-credit-card-join-costco-link-clicked', data)
        }
        if (event.id === 'costcoBusinessJoinLink') {
          const data = this._getCostcoTaggingData({ page_inter: event.domElement.textContent })
          this._mktTagging.tagMktCompareCards('citi-costco-credit-card-join-costco-link-clicked', data)
        }
        if (event.id === 'costcoRewardsSectionJoinLink') {
          const data = this._getCostcoTaggingData({ page_inter: event.domElement.textContent })
          this._mktTagging.tagMktCompareCards('citi-costco-credit-card-join-costco-link-clicked', data)
        }
        if (event.id === 'costcoBusinessRewardsSectionJoinLink') {
          const data = this._getCostcoTaggingData({ page_inter: event.domElement.textContent })
          this._mktTagging.tagMktCompareCards('citi-costco-credit-card-join-costco-link-clicked', data)
        }
      }),
      takeWhile(() => this.isComponentActive)
    ).subscribe();
  }
  /**
   *
   * returns Tag Data Object to record when tagging event called
   */
  private _getCostcoTaggingData(data = {}) {
    const hashCode = this.hashCode;
    const productName = this.mktDynamicOfferService.productType[this.pid];
    const prospectId = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl)
    return {
      ...data,
      app_hierarchy: `public|marketing|${productName}|pdp:anchor link clicked`,
      card_product_name: productName,
      pid: this.pid,
      affinity_code: this.afcCode,
      prospect_id: prospectId,
      products: [{
        category: 'cards:acquisition',
        product_name: 'c:' + this.pid,
        acquisition_source_code: hashCode,
        product_details: this._productDetails()
      }]
    }
  }

  /**
   *
   * returns Tag Data Object to record when tagging event called
   */
  private _getexitLinkClickData(data : any) {
    const hashCode = this.hashCode;
    const productName = this.mktDynamicOfferService.productType[this.pid];
    const prospectId = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl)
    return {
      ...data,
      app_hierarchy: `public|marketing|${productName}|pdp:exit link clicked`,
      card_product_name: productName,
      pid: productName,
      affinity_code: this.afcCode,
      prospect_id: prospectId,
      link_name: `${data?.exit_link_section}|${data?.exit_link_title} `,
      products: [{
        category: 'cards:acquisition',
        product_name: 'c:' + ((this.cardDetails?.isCRSPage) ? this.productName : this.pid),
        acquisition_source_code: hashCode,
        product_details: this._productDetails()
      }]
    }
  }

  /**
   *
   * returns Tag Data Object to record when tagging event called
   */
  private _getNewTabClickData(data : any) {
    const hashCode = this.hashCode;
    const productName = this.mktDynamicOfferService.productType[this.pid];
    const prospectId = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl)
    return {
      ...data,
      app_hierarchy: `public|marketing|${productName}|pdp:new tab selected`,
      card_product_name: productName,
      pid: productName,
      affinity_code: this.afcCode,
      prospect_id: prospectId,
      page_inter: `${data?.tabIndex}|${data?.page_inter}`,
      products: [{
        category: 'cards:acquisition',
        product_name: 'c:' + ((this.cardDetails?.isCRSPage) ? this.productName : this.pid),
        acquisition_source_code: hashCode,
        product_details: this._productDetails()
      }]
    }
  }

  callToApplyClicked(value) {
    if (value === 'callToApplyClicked' && PDP_CALL_TO_APPY_PID_LIST.includes(this.pid.toString())) {
      const hashCode = this.hashCode;
      const productName = this.mktDynamicOfferService.productType[this.pid];
      const prospectId = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl)
      const callToApplyTaggingObj = {
        app_hierarchy: `public|marketing|${productName}|pdp:call to apply`,
        pid: this.pid,
        affinity_code: this.afcCode,
        prospect_id: prospectId,
        products: [{
          category: 'cards:acquisition',
          product_name: 'c:' + this.pid,
          acquisition_source_code: hashCode,
          product_details: this._productDetails()
        }]
      }

      this._mktTagging.tagMktCompareCards('pdp_call_to_apply', callToApplyTaggingObj)
    }
  }

  //tagging for Pricing link in price-detail-section
  pricingLinkTagging(value) {
    let taggingValue;
    if(value == "pricingInfoLinkHero")
      taggingValue = 'Important Pricing & Information|Hero';
    else if(value == "pricingInfoLinkBody")
      taggingValue = "Important Pricing & Information|Body";
    else if(value == "additionalInfoLinkHero")
      taggingValue = "Additional Information|Hero";
    else if(value == "additionalInfoLinkBody")
      taggingValue = "Additional Information|Body";
    this._mktTagging.tagMktCompareCards("pdp-PricingInfoLink", {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|pdp:internal link clicked`,
      link_name: `${taggingValue}`,
    });
  }

  additionalInfoLinkTagging(event) {
    this._mktTagging.tagMktCompareCards("pdp-AdditionalInfoLink", {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|pdp:additional information`,
    });
  }


  //tagging for Pricing link in header section, Reviews, FAQ links
  anchorLinkTagging(value) {
    this._mktTagging.tagMktCompareCards("pdp-AnchorLink", {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|pdp:anchor link clicked`,
      page_inter: value
    });
  }

  accordionTagging(data: any): void {
    const accordionTaggingObj = data.show ? '196_4l9CardsProductDetailsPage_ShowAccordionSection' : '196_4l10CardsProductDetailsPage_HideAccordionSection';
    const app_hierarchy_accordion = data.show ? `pdp:show accordion section` : `pdp:hide accordion section`;
    const dynamicContent = {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|${app_hierarchy_accordion}`,
      page_inter: data.page_inter
    };
    this._mktTagging.triggerEventTagging('nonicms_content', accordionTaggingObj, { dynamicContent });
  }

  applyNowTagging(value) {
    let taggingValue = PDPAPPLYNOWTAGGING[value];
    if (value.includes('cardArtBodyCRS') && !taggingValue) {
      taggingValue = PDPAPPLYNOWTAGGING['cardArtBodyCRS'];
    }
    if (value.includes('applyNowBodyCRS') && !taggingValue) {
      taggingValue = PDPAPPLYNOWTAGGING['applyNowBodyCRS'];
    }
    this._mktTagging.tagMktCompareCards("pdp-ApplyNowButton", {
      ...this.taggingObj,
      app_hierarchy: `public|marketing|${this.productName}|pdp:apply now`,
      link_name: `${taggingValue}`
    });
  }

  earningsCalculatorTagging(value) {
    if (value.type === 'link') {
      this.pricingLinkTagging(value);
    } else {
      this._mktTagging.tagMktCompareCards("earnings-calculator-interaction", {
        ...this.taggingObj,
        app_hierarchy: `public|marketing|${this.productName}|pdp:earnings calculator interaction`,
        page_inter: value.page_inter
      });
    }
  }

  loadRatings() {
    const ratingsReviewConfig = this._mktContentService.get("Branding", "copy", "ratings-reviews-config", undefined);
    let { cards } = JSON.parse(ratingsReviewConfig?.["cards-with-rr"] || "{}");
    this.state.set(CARDS_WITH_RATINGS_KEY, cards);
  }

  private _getPdpDisplayOrder(orderObj: any) {
    if (!orderObj) {
      orderObj = { "header-section": 1 }
    }
    return orderObj && Object.keys(orderObj).sort((a, b) => orderObj[a] - orderObj[b]);
  }

  private _exitLinkClicked() {
    this._mktEventListnerService.eventListner$.pipe(
      tap(event => {
        if (event.id === 'exitLink') {
          const exit_link_section = 'Hero';
          const exit_link_title = event.domElement.textContent;
          const data = this._getexitLinkClickData({ page_inter: event.domElement.textContent,exit_link_section,exit_link_title })
          this._mktTagging.tagMktCompareCards('exitLink', data)
        }
        if (event.id === 'wayfairAccountexitLink') {
          const exit_link_section = 'Wayfair Credit Card';
          const exit_link_title = event.domElement.textContent;
          const data = this._getexitLinkClickData({ page_inter: event.domElement.textContent,exit_link_section,exit_link_title })
          this._mktTagging.tagMktCompareCards('exitLink', data)
        }
        if (event.id === 'wayfairAccountexitLinkSection2') {
          const exit_link_section = 'Wayfair MasterCard';
          const exit_link_title = event.domElement.textContent;
          const data = this._getexitLinkClickData({ page_inter: event.domElement.textContent,exit_link_section,exit_link_title })
          this._mktTagging.tagMktCompareCards('exitLink', data)
        }
      })
    ).subscribe();
  }

  private newTabLinkClick() {
    this._mktEventListnerService.eventListner$.pipe(
      tap(event => {
        if (event.id === 'benefitSectionNewTabLink0') {
          const tabIndex = 1;
          const data = this._getNewTabClickData({ page_inter: event.domElement.textContent, tabIndex })
          this._mktTagging.tagMktCompareCards('citi_wayfair_benefit_section_new_tab_selected', data)
        }
        if (event.id === 'benefitSectionNewTabLink1') {
          const tabIndex = 2;
          const data = this._getNewTabClickData({ page_inter: event.domElement.textContent , tabIndex })
          this._mktTagging.tagMktCompareCards('citi_wayfair_benefit_section_new_tab_selected', data)
        }
        if (event.id === 'benefitSectionNewTabLink2') {
          const tabIndex = 3;
          const data = this._getNewTabClickData({ page_inter: event.domElement.textContent, tabIndex })
          this._mktTagging.tagMktCompareCards('citi_wayfair_benefit_section_new_tab_selected', data)
        }
      }),
      takeWhile(() => this.isComponentActive)
    ).subscribe();
  }
}

export enum PdpDisplayOrderName {
  HEADER_SECTION = 'header-section',
  COMPARE_CARD_SECTION = 'compare-cards-section',
  REWARDS_SECTION = 'rewards-section',
  PROGRAM_DETAIL_SECTION = 'program-details-section',
  BENEFIT_SECTION = 'benefit-section',
  CREDIT_CARD_WORK_SECTION = 'credit-card-work',
  FAQ_SECTION = 'faq-section',
  REVIEW_SECTION = 'review-section',
  FUTURE_SECTION = 'feature-section',
  PRICING_DETAIL_SECTION = 'price-detail-section',
  EARNING_CALCULATOR_SECTION = 'earnings-calculator-section'
}
